import { createContext, useContext, useState, useEffect } from 'react';

// 翻訳辞書
const translations = {
  ja: {
    // ナビゲーション・一般
    appTitle: 'AniVal',
    addAnime: 'アニメを追加',
    search: 'アニメ／声優／制作会社／監督 を検索...',
    allDisplay: 'すべて表示',
    yearDisplay: '年別表示',
    seasonDisplay: 'クール別表示',
    noRankFilter: 'ランク指定なし',
    noStatusFilter: 'ステータス指定なし',
    
    // 並び替え
    sortBy: '並び替え',
    sortRankAsc: 'ランク昇順',
    sortRankDesc: 'ランク降順', 
    sortYearAsc: '年度昇順',
    sortYearDesc: '年度降順',
    sortTitleAsc: 'タイトル昇順',
    sortTitleDesc: 'タイトル降順',
    
    // ステータス
    watching: '視聴中',
    complete: '完走',
    dropped: '脱落',
    notStarted: '未視聴',
    
    // シーズン
    spring: '春',
    summer: '夏',
    autumn: '秋',
    winter: '冬',
    springCour: '春',
    summerCour: '夏',
    autumnCour: '秋',
    winterCour: '冬',
    springEn: 'Spring',
    summerEn: 'Summer', 
    autumnEn: 'Fall',
    winterEn: 'Winter',
    
    // Season values for selects
    springValue: '\u6625',
    summerValue: '\u590f', 
    autumnValue: '\u79cb',
    winterValue: '\u51ac',
    
    // 評価関連
    rating: '評価',
    noRating: '未評価',
    averageRating: '平均評価',
    ratingMode: '評価モード',
    simpleRating: 'シンプル評価',
    detailedRating: '詳細評価',
    simpleRatingDesc: '5段階',
    maxCharacters: '最大3人',
    content: '内容',
    animation: '作画',
    sound: '音響（声優・BGM・曲）',
    
    // アニメ情報
    year: '年',
    broadcastYear: '放送年',
    episodes: '話数',
    broadcastDay: '配信曜日',
    streamingSite: '配信サイト',
    studio: '制作会社',
    director: '監督',
    officialSite: '公式サイトを見る',
    officialX: '公式Xを見る',
    pvWatch: 'PVを見る',
    favoriteCharacters: '推しキャラクター',
    
    // 主題歌
    opening: 'オープニング',
    ending: 'エンディング',
    songTitle: '曲名',
    artist: 'アーティスト名',
    addOP: 'OP追加（2クール目など）',
    addED: 'ED追加（2クール目など）',
    
    // エピソード
    episodeList: '各話リスト',
    episode: '第{number}話',
    unwatched: '未視聴',
    rateEpisode: '評価する',
    editRating: '評価を編集',
    episodeRating: '第{number}話の評価',
    storyTitle: 'ストーリータイトル（任意）',
    memo: 'メモ（任意）',
    memoPlaceholder: 'このエピソードの感想を記録...',
    dropHere: 'ここで視聴を断念する',
    droppedAt: '第{number}話で脱落',
    viewingAbandoned: '視聴断念',
    
    // ボタン・アクション
    edit: '編集',
    save: '保存',
    saving: '保存中...',
    cancel: 'キャンセル',
    delete: '削除',
    add: '追加',
    close: '閉じる',
    back: '戻る',
    reviveFromDrop: '脱落から復帰',
    logout: 'ログアウト',
    syncing: '同期中...',
    synced: '同期済み',
    syncedAt: '{time} 同期済み',
    
    // フォーム
    title: 'タイトル',
    subtitle: 'サブタイトル（任意）',
    totalEpisodes: '総話数',
    startEpisode: '開始話数',
    thumbnail: 'サムネイル',
    selectImage: '画像を選択',
    cropImage: '画像をクロップ',
    
    // 確認メッセージ・エラー
    deleteConfirm: 'このアニメを削除しますか？',
    loading: '読み込み中...',
    uploadFailed: '画像のアップロードに失敗しました',
    maxCharacters: '最大3人',
    passwordMismatch: 'パスワードが一致しません',
    userNotFound: 'ユーザーが見つかりません',
    wrongPassword: 'パスワードが間違っています',
    emailInUse: 'このメールアドレスは既に使用されています',
    weakPassword: 'パスワードは6文字以上で入力してください',
    invalidEmail: '無効なメールアドレスです',
    errorOccurred: 'エラーが発生しました',
    processing: '処理中...',
    enterEmailFirst: '先にメールアドレスを入力してください',
    resetEmailSent: 'パスワード再設定用メールを送信しました',
    emailSendFailed: 'メール送信に失敗しました',
    appDescription: 'クラウド同期対応のアニメ評価アプリ',
    confirmPassword: 'パスワード（確認）',
    passwordMinLength: 'パスワード（6文字以上）',
    
    // ログイン・認証
    email: 'メールアドレス',
    password: 'パスワード',
    signIn: 'ログイン',
    signUp: 'アカウント作成',
    resetPassword: 'パスワードをリセット',
    createAccount: 'アカウントを作成する',
    alreadyHaveAccount: 'すでにアカウントをお持ちの方',
    forgotPassword: 'パスワードをお忘れの方',
    resetPasswordDesc: 'パスワードリセット用のメールを送信します',
    backToLogin: 'ログインに戻る',
    sendResetEmail: 'リセットメールを送信',
    
    // 統計・トレンド
    statistics: '統計情報',
    averageRatingTrend: '平均評価の推移',
    ratingTrend: '評価推移',
    switchToCompactScale: 'データ範囲に合わせる',
    switchToFullScale: '0-5の全体表示',
    average: '平均',
    standardDeviation: '標準偏差',
    animeCount: '作品数',
    dataInsufficient: 'データが不足しています',
    totalAnime: '総アニメ数',
    completedAnime: '完走アニメ',
    watchingAnime: '視聴中アニメ',
    droppedAnime: '脱落アニメ',
    totalEpisodesWatched: '総視聴話数',
    averageScore: '平均スコア',
    highestRated: '最高評価',
    lowestRated: '最低評価',
    completionRate: '完走率',
    dropRate: '脱落率',
    rankDistribution: 'ランク分布',
    noDataAvailable: 'データがありません',
    
    // フォーム詳細
    episodeNumber: '話数',
    startFrom: '開始話数',
    imageUpload: '画像アップロード',
    characterName: 'キャラクター名',
    voiceActor: '声優',
    addCharacter: 'キャラクター追加',
    removeCharacter: 'キャラクター削除',
    links: 'リンク',
    officialWebsite: '公式サイト',
    officialTwitter: '公式X (Twitter)',
    previewVideo: 'PV (YouTube)',
    
    // 編集フォーム
    editAnime: 'アニメ編集',
    totalEpisodes: '総話数',
    broadcastInfo: '配信・制作情報',
    themeMusic: '主題歌',
    openingTheme: 'オープニング主題歌',
    endingTheme: 'エンディング主題歌',
    cropAndUpload: 'クロップしてアップロード',
    noImageSelected: '画像が選択されていません',
    maxCharactersLimit: '最大3人',
    episodeInfo: 'エピソード情報',
    adjustEpisodeCount: 'エピソード数調整',
    increaseEpisodes: '話数を増やす（続編・分割クールなど）',
    currentEpisodes: '現在の話数',
    startEpisodeNum: '開始話数',
    thumbnailImage: 'サムネイル画像',
    uploadThumbnail: 'サムネイルをアップロード',
    editFormSave: '保存して閉じる',
    editFormCancel: 'キャンセル',
    characterImage: 'キャラクター画像',
    noCharacterImage: 'キャラクター画像なし',
    yearSuffix: '年',
    courseSuffix: 'クール',
    episodeSuffix: '話',
    episodes: '話',
    
    // エピソード表示
    watchedDate: '視聴日',
    detailedBreakdown: '詳細内訳',
    episodeNotes: 'エピソードの感想',
    storyTitlePlaceholder: '例: ○○との出会い',
    broadcastDayExample: '土曜日',
    directorExample: '新海誠',
    studioExample: 'A-1 Pictures',
    streamingSiteExample: 'Netflix',
    
    // その他
    completed: '完了',
    progress: '{progress}% 完了',
    rank: 'ランク',
    status: 'ステータス',
    registered: '未登録',
    simple: 'シンプル',
    detailed: '詳細',
    example: '例',
    optional: '任意',
    required: '必須',
    selectFile: 'ファイルを選択',
    noFile: 'ファイルが選択されていません',
    noSelection: '選択なし',
    language: 'ja'
  },
  
  en: {
    // Navigation & General
    appTitle: 'AniVal',
    addAnime: 'Add Anime',
    search: 'Search anime/voice actor/studio/director...',
    allDisplay: 'Show All',
    yearDisplay: 'By Year',
    seasonDisplay: 'By Season',
    noRankFilter: 'No Rank Filter',
    noStatusFilter: 'No Status Filter',
    
    // Sorting
    sortBy: 'Sort by',
    sortRankAsc: 'Rank (Low to High)',
    sortRankDesc: 'Rank (High to Low)',
    sortYearAsc: 'Year (Old to New)',
    sortYearDesc: 'Year (New to Old)',
    sortTitleAsc: 'Title (A to Z)',
    sortTitleDesc: 'Title (Z to A)',
    
    // Status
    watching: 'Watching',
    complete: 'Completed',
    dropped: 'Dropped',
    notStarted: 'Not Started',
    
    // Seasons
    spring: 'Spring',
    summer: 'Summer',
    autumn: 'Fall',
    winter: 'Winter',
    springCour: 'Spring',
    summerCour: 'Summer',
    autumnCour: 'Fall',
    winterCour: 'Winter',
    springEn: 'Spring',
    summerEn: 'Summer',
    autumnEn: 'Fall', 
    winterEn: 'Winter',
    
    // Season values for selects  
    springValue: 'Spring',
    summerValue: 'Summer',
    autumnValue: 'Fall', 
    winterValue: 'Winter',
    
    // Rating
    rating: 'Rating',
    noRating: 'Not Rated',
    averageRating: 'Average Rating',
    ratingMode: 'Rating Mode',
    simpleRating: 'Simple Rating',
    detailedRating: 'Detailed Rating',
    simpleRatingDesc: '5-point',
    maxCharacters: 'Max 3',
    content: 'Content',
    animation: 'Animation',
    sound: 'Sound (Voice/BGM/Music)',
    
    // Anime Info
    year: '',
    broadcastYear: 'Broadcast Year',
    episodes: 'Episodes',
    broadcastDay: 'Broadcast Day',
    streamingSite: 'Streaming Site',
    studio: 'Studio',
    director: 'Director',
    officialSite: 'Visit Official Site',
    officialX: 'Visit Official X',
    pvWatch: 'Watch PV',
    favoriteCharacters: 'Favorite Characters',
    
    // Theme Songs
    opening: 'Opening',
    ending: 'Ending',
    songTitle: 'Song Title',
    artist: 'Artist Name',
    addOP: 'Add OP (2nd cour, etc.)',
    addED: 'Add ED (2nd cour, etc.)',
    
    // Episodes
    episodeList: 'Episode List',
    episode: 'Episode {number}',
    unwatched: 'Unwatched',
    rateEpisode: 'Rate',
    editRating: 'Edit Rating',
    episodeRating: 'Rating for Episode {number}',
    storyTitle: 'Story Title (Optional)',
    memo: 'Memo (Optional)',
    memoPlaceholder: 'Record your thoughts on this episode...',
    dropHere: 'Drop anime here',
    droppedAt: 'Dropped at Episode {number}',
    viewingAbandoned: 'Viewing Abandoned',
    
    // Buttons & Actions
    edit: 'Edit',
    save: 'Save',
    saving: 'Saving...',
    cancel: 'Cancel',
    delete: 'Delete',
    add: 'Add',
    close: 'Close',
    back: 'Back',
    reviveFromDrop: 'Revive from Drop',
    logout: 'Logout',
    syncing: 'Syncing...',
    synced: 'Synced',
    syncedAt: 'Synced at {time}',
    
    // Forms
    title: 'Title',
    subtitle: 'Subtitle (Optional)',
    totalEpisodes: 'Total Episodes',
    startEpisode: 'Start Episode',
    thumbnail: 'Thumbnail',
    selectImage: 'Select Image',
    cropImage: 'Crop Image',
    
    // Confirmation & Errors
    deleteConfirm: 'Are you sure you want to delete this anime?',
    loading: 'Loading...',
    uploadFailed: 'Failed to upload image',
    maxCharacters: 'Maximum 3 favorite characters allowed',
    passwordMismatch: 'Passwords do not match',
    userNotFound: 'User not found',
    wrongPassword: 'Incorrect password',
    emailInUse: 'Email address is already in use',
    weakPassword: 'Password must be at least 6 characters',
    invalidEmail: 'Invalid email address',
    errorOccurred: 'An error occurred',
    processing: 'Processing...',
    enterEmailFirst: 'Please enter email address first',
    resetEmailSent: 'Password reset email sent',
    emailSendFailed: 'Failed to send email',
    appDescription: 'Cloud-synced anime rating app',
    confirmPassword: 'Confirm Password',
    passwordMinLength: 'Password (6+ characters)',
    
    // Login & Auth
    email: 'Email Address',
    password: 'Password',
    signIn: 'Sign In',
    signUp: 'Sign Up',
    resetPassword: 'Reset Password',
    createAccount: 'Create Account',
    alreadyHaveAccount: 'Already have an account?',
    forgotPassword: 'Forgot password?',
    resetPasswordDesc: 'Send password reset email',
    backToLogin: 'Back to Login',
    sendResetEmail: 'Send Reset Email',
    
    // Statistics & Trends
    statistics: 'Statistics',
    averageRatingTrend: 'Average Rating Trend',
    ratingTrend: 'Rating Trend',
    switchToCompactScale: 'Fit to data range',
    switchToFullScale: 'Show full 0-5 range',
    average: 'Average',
    standardDeviation: 'Standard Deviation',
    animeCount: 'Anime Count',
    dataInsufficient: 'Insufficient data',
    totalAnime: 'Total Anime',
    completedAnime: 'Completed Anime',
    watchingAnime: 'Watching Anime',
    droppedAnime: 'Dropped Anime',
    totalEpisodesWatched: 'Total Episodes Watched',
    averageScore: 'Average Score',
    highestRated: 'Highest Rated',
    lowestRated: 'Lowest Rated',
    completionRate: 'Completion Rate',
    dropRate: 'Drop Rate',
    rankDistribution: 'Rank Distribution',
    noDataAvailable: 'No data available',
    
    // Form Details
    episodeNumber: 'Episodes',
    startFrom: 'Start Episode',
    imageUpload: 'Image Upload',
    characterName: 'Character Name',
    voiceActor: 'Voice Actor',
    addCharacter: 'Add Character',
    removeCharacter: 'Remove Character',
    links: 'Links',
    officialWebsite: 'Official Website',
    officialTwitter: 'Official X (Twitter)',
    previewVideo: 'PV (YouTube)',
    
    // Edit Form
    editAnime: 'Edit Anime',
    totalEpisodes: 'Total Episodes',
    broadcastInfo: 'Broadcast & Production Info',
    themeMusic: 'Theme Music',
    openingTheme: 'Opening Theme Song',
    endingTheme: 'Ending Theme Song',
    cropAndUpload: 'Crop and Upload',
    noImageSelected: 'No image selected',
    maxCharactersLimit: 'Maximum 3 favorite characters allowed',
    episodeInfo: 'Episode Information',
    adjustEpisodeCount: 'Adjust Episode Count',
    increaseEpisodes: 'Increase episodes (sequel, split-cour, etc.)',
    currentEpisodes: 'Current episodes',
    startEpisodeNum: 'Start Episode Number',
    thumbnailImage: 'Thumbnail Image',
    uploadThumbnail: 'Upload Thumbnail',
    editFormSave: 'Save & Close',
    editFormCancel: 'Cancel',
    characterImage: 'Character Image',
    noCharacterImage: 'No Character Image',
    yearSuffix: '',
    courseSuffix: '',
    episodeSuffix: ' episodes',
    episodes: ' episodes',
    
    // Episode Display
    watchedDate: 'Watched Date',
    detailedBreakdown: 'Detailed Breakdown',
    episodeNotes: 'Episode Notes',
    storyTitlePlaceholder: 'e.g., Meeting with ○○',
    broadcastDayExample: 'Saturday',
    directorExample: 'Makoto Shinkai',
    studioExample: 'A-1 Pictures',
    streamingSiteExample: 'Netflix',
    
    // Others
    completed: 'Completed',
    progress: '{progress}% Complete',
    rank: 'Rank',
    status: 'Status',
    registered: 'Not Registered',
    simple: 'Simple',
    detailed: 'Detailed',
    example: 'e.g.',
    optional: 'Optional',
    required: 'Required',
    selectFile: 'Select File',
    noFile: 'No file selected',
    noSelection: 'No selection',
    language: 'en'
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('anime-app-language') || 'ja';
  });

  useEffect(() => {
    localStorage.setItem('anime-app-language', language);
  }, [language]);

  const t = (key, params = {}) => {
    let text = translations[language]?.[key] || translations.ja[key] || key;
    
    // パラメータ置換
    Object.keys(params).forEach(param => {
      text = text.replace(`{${param}}`, params[param]);
    });
    
    return text;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'ja' ? 'en' : 'ja');
  };

  return (
    <LanguageContext.Provider value={{ language, t, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
